import React, { useEffect, useState } from 'react';
import { Row, Col, Typography, Input, Button, Space, message, Form } from 'antd';
import { CopyOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { AddUpdateWhatsapp, getOmni } from '../../redux/OmniChannels/OmniChannelsActions';

const { Title, Text } = Typography;

const WhatsappConfigration = () => {
    const [form] = Form.useForm();
    const [secretTokenVisible, setSecretTokenVisible] = useState(false);
    const [secretTokenVisiblee, setSecretTokenVisiblee] = useState(false);
    const userData = useSelector((state) => state.Auth.userData);
    const usertoken = useSelector((state) => state.Auth.token);
    const { data, loading_state, omniData } = useSelector((state) => state.OmniChannelsReducer);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getOmni({ companyId: userData?.companyId }));
    }, []);

    const webhookUrl = 'https://apigateway.convobird.com/agents/whatsapp';

    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            message.success('Copied!');
        } catch {
            message.error('Failed to copy!');
        }
    };

    const handleSubmit = (values) => {
        let newData = {
            ...values,
            companyId: userData?.companyId
        }
        dispatch(AddUpdateWhatsapp(newData, usertoken))
    };

    useEffect(() => {
        if (omniData) {
            form.setFieldsValue({
                access_token: omniData.access_token,
                phone_number_id: omniData.phone_number_id,
            });
        }
    }, [omniData, form]);

    return (
        <div style={{ padding: 24, background: '#fff', borderRadius: 12 }}>
            <Row gutter={32}>
                {/* LEFT SIDE */}
                <Col xs={24} md={12}>
                    <Title level={4}>WhatsApp Configuration</Title>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                    >
                        <Form.Item
                            label="Access Token"
                            name="access_token"
                            rules={[{ required: true, message: 'Please input your access token' }]}
                        >
                            <Input.Password
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                                onClick={() => setSecretTokenVisiblee(!secretTokenVisiblee)}
                            />
                            {/* <Input placeholder="Enter WhatsApp Access Token" /> */}
                        </Form.Item>

                        <Form.Item
                            label="Phone Number ID"
                            name="phone_number_id"
                            rules={[{ required: true, message: 'Please input your phone number ID' }]}
                        >
                            <Input type='number' placeholder="Enter Phone Number ID" />
                        </Form.Item>

                        <Form.Item>
                            <Button disabled={loading_state} type="primary" htmlType="submit">
                                Submit Config
                            </Button>
                        </Form.Item>
                    </Form>

                    <Text style={{color:"darkorange"}}>
                        ⚠️ Provide the correct Access Token and Phone Number ID.
                        If the phone number doesn't match the one registered with WhatsApp, you won't receive messages.
                    </Text>
                </Col>

                {/* RIGHT SIDE */}
                <Col xs={24} md={12}>
                    <Title level={4}>Configuration Info</Title>

                    <Text>Webhook URL</Text>
                    <Space.Compact style={{ width: '100%', marginBottom: 10, marginTop: 7 }}>
                        <Input readOnly value={webhookUrl} />
                        <Button icon={<CopyOutlined />} onClick={() => handleCopy(webhookUrl)} />
                    </Space.Compact>

                    <Text>Secret Token</Text>
                    <Space.Compact style={{ width: '100%', marginTop: 7 }}>
                        <Input.Password
                            readOnly
                            value={userData?.companyId}
                            iconRender={(visible) =>
                                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                            }
                            onClick={() => setSecretTokenVisible(!secretTokenVisible)}
                        />
                        <Button icon={<CopyOutlined />} onClick={() => handleCopy(userData?.companyId)} />
                    </Space.Compact>
                </Col>
            </Row>
        </div >
    );
};

export default WhatsappConfigration;
